import type { ReactNode } from "react";

export function AdminPageShell({
  title,
  description,
  toolbar,
  fill,
  children,
}: {
  title: string;
  description?: string;
  toolbar?: ReactNode;
  /** 铺满右侧主内容区，表格区域可 flex 撑高 */
  fill?: boolean;
  children: ReactNode;
}) {
  return (
    <div className={`admin-ledger-page${fill ? " admin-ledger-page--fill" : ""}`}>
      <div className="admin-ledger-page-head">
        <div>
          <h1 className="admin-ledger-title">{title}</h1>
          {description ? <p className="admin-ledger-desc">{description}</p> : null}
        </div>
        {toolbar ?? null}
      </div>
      {children}
    </div>
  );
}
